import { RouteObjectWithPlugins, useRenderedRouteLoaderData } from '@/reactRouterPlugins';
import { InstallationKeyAbout } from './about';
import {
  InstallationKeyLoaderResult,
  installationLoader,
  InstallationPage,
  InstallationPageSkeleton,
} from './installationKey';

const id = 'installationKey';

export const installationKeyRoute: RouteObjectWithPlugins = {
  id,
  gbifRedirect: ({ key } = {}, { gbifOrgLocalePrefix = '' }) => {
    if (typeof key !== 'string' && typeof key !== 'number')
      throw new Error(`'Invalid key (key is of type ${typeof key})`);
    if (key === 'search') return null;
    return `${import.meta.env.PUBLIC_GBIF_ORG}${gbifOrgLocalePrefix}/installation/${key}`;
  },
  path: 'installation/:key',
  loader: installationLoader,
  loadingElement: <InstallationPageSkeleton />,
  element: <InstallationPage />,
  children: [
    {
      index: true,
      element: <InstallationKeyAbout />,
    },
  ],
};

export function useInstallationKeyLoaderData() {
  return useRenderedRouteLoaderData(id) as InstallationKeyLoaderResult;
}
